import React from 'react'
import AllProduct from '../components/home/allProduct'
import Navbar from '../components/common/navbar'
import Footer from '../components/common/footer'

const AllProductPage = () => {
  return (
    <div>
        <Navbar/>
        <div className="md:mx-16"><AllProduct/></div>
        
        <Footer />
    </div>
  )
}

export default AllProductPage